module.exports = __webpack_public_path__ + "static/media/tk.e64b0977.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/tk.svg
// module id = 2226
// module chunks = 0